import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  references: [
    {
      id: 1,
      first_name: "John",
      last_name: "Doe",
      reference_id: 12,
      email: "john.doe@example.com",
      date_created: "2025-01-01",
    },
    {
      id: 2,
      first_name: "Jane",
      last_name: "Smith",
      reference_id: 13,
      email: "jane.smith@example.com",
      date_created: "2025-02-15",
    },
    {
      id: 3,
      first_name: "Alex",
      last_name: "Johnson",
      reference_id: 14,
      email: "alex.johnson@example.com",
      date_created: "2025-03-10",
    },
  ],
  isModalOpen: false,
  loading: false,
  error: "",
};

const referenceSlice = createSlice({
  name: "reference",
  initialState,
  reducers: {
    openModal: (state) => {
      state.isModalOpen = true;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
    },
    addReference: (state, action) => {
      state.references.push({
        ...action.payload,
        id: state.references.length + 1,
      });
    },
    deleteReference: (state, action) => {
      state.references = state.references.filter(
        (reference) => reference.id !== action.payload
      );
    },
    editReference: (state, action) => {
      const { id, updatedReference } = action.payload;
      const index = state.references.findIndex(
        (reference) => reference.id === id
      );
      if (index !== -1) {
        state.references[index] = {
          ...state.references[index],
          ...updatedReference,
        };
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  openModal,
  closeModal,
  addReference,
  deleteReference,
  editReference,
  setLoading,
  setError,
} = referenceSlice.actions;

export default referenceSlice.reducer;
